module.exports = __webpack_public_path__ + "static/media/bg_03.79b951c1.jpg";